import { showLoaderSaga } from '../sagas/loaderSagas';
import { loaderUtilLoaderConfigOverride } from './loaderUtilLoaderConfigOverride';

/**
 * Creates a loader configuration that is then attached to the component.
 * The configuration is used when attaching and removing the loader.
 * @param {object} component - The component that the loader config is being set on
 * @param {object} loaderOverrides - An object representing loader config overrides supplied by the component.
 *                                   Undefined by default.
 * @param {string} loaderOverrides.contents - An html string of the contents of the loader
 * @param {boolean} loaderOverrides.onWindow - Controls whether to have the loader overtake the whole page or not
 * @param {string} loaderOverrides.buttonLoader - A jquery selector representing a button to attach a loader to
 * @param {string} loaderOverrides.location - A location override to attach the loader to
 * @param {string} loaderOverrides.loaderUUID - A unique class attached to a loader, used for removal
 * @param {string} loaderOverrides.inlineStyles - Style properties attached inline to the modal element,
 *                                                used to override the default loader styles.
 * @param {number} loaderOverrides.delay - A number, in ms,  representing how long to wait to attach the loader
 * @return {object} - A loader config returned to set the components loader
 */
export function generateLoader(component, loaderOverrides = {}) {
    const loaderContents = loaderUtilLoaderConfigOverride;

    const defaultLoader = {
        onWindow: false,
        contents: loaderContents,
        buttonLoader: '',
        location: component.templateLocation,
        loaderUUID: `js-loader-${Date.now()}`,
        inlineStyles: '',
        delay: 100
    };

    const loaderConfig = Object.assign(
        {}, defaultLoader, component.loader, loaderOverrides
    );

    const loaderClass = loaderConfig.onWindow ? 'o-loader o-loader--full' : 'o-loader';
    const placement = loaderConfig.onWindow ? 'body' :
                      loaderConfig.location ? loaderConfig.location :
                      component.templateLocation;

    return Object.assign(
        {}, loaderConfig, {
            element: `<div class="js-loader ${loaderConfig.loaderUUID} ${loaderClass}" style="${loaderConfig.inlineStyles}">${loaderConfig.contents}</div>`, // eslint-disable-line max-len
            placement: placement
        }
    );
}

/**
 * Generate a loader and then attach to the configured location on the page
 * @param {object} store - The redux store object
 * @param {object} loaderOverrides options to override default loader behavior
 * @return {undefined}
 */
export function attachLoader(store = {}, loaderOverrides = {}) {
    this.loader = generateLoader(this, loaderOverrides);
    store.runSaga(showLoaderSaga, this);
}

export function showLoader(component) {
    $(component.loader.placement).prepend(component.loader.element);
}

/**
 * Remove a loader from the page that has the current UUID class
 * @param {object} store - The redux store object
 * @return {undefined}
 */
export function removeLoader(store = {}) {
    hideLoader(this);
}

export function hideLoader(component = {}) {
    if (component.loader) {
        $(`.${component.loader.loaderUUID}`).detach();
        component.loader = null;
    } else {
        $('.js-loader').detach();
    }
}
